/* Publish by EComposer at 2026-10-25 18:26:19*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-fmi3a7njsxb"]=  window.__ectimmers["ecom-fmi3a7njsxb"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-fmi3a7njsxb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmi3a7njsxb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3irn8d6znks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3irn8d6znks', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3k78cwrwqs4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3k78cwrwqs4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3jh4vjd2k0j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3jh4vjd2k0j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c8qkc682p96').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c8qkc682p96', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f10kj59w31r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f10kj59w31r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fz6s6r3gy7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fz6s6r3gy7c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v6k1j1aulp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v6k1j1aulp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dy8kmhwj0u7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dy8kmhwj0u7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6gsmden5h4t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6gsmden5h4t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4dcqk6rfkk6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4dcqk6rfkk6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vkpb8s7d8b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vkpb8s7d8b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zsfjhq0yr9q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zsfjhq0yr9q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o7z718gz41k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o7z718gz41k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fs14zltd4hl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fs14zltd4hl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mrvc6jgz8wb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mrvc6jgz8wb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lwdewb8sexc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lwdewb8sexc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-daa66jokom').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-daa66jokom', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3v33d8a69ta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3v33d8a69ta', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dwwxu6rx8nq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dwwxu6rx8nq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0mhi8p5bzcqd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0mhi8p5bzcqd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n4kxvgjy89r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n4kxvgjy89r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ht6lp2bg83j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ht6lp2bg83j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fudpn172m4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fudpn172m4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ffe6rt3o8nh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ffe6rt3o8nh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q5v60wj9jhn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q5v60wj9jhn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ixrljlkel').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ixrljlkel', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xx9vjlmgjoi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xx9vjlmgjoi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5xh7dy90oas').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5xh7dy90oas', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ctqltz54o9e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ctqltz54o9e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5uog0uejsk9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5uog0uejsk9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-orfcba8hj1d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-orfcba8hj1d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qbpsxyhq4n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qbpsxyhq4n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u3b88rst3n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u3b88rst3n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k45y0k4bmx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k45y0k4bmx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jdaex7dycc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jdaex7dycc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tgz09ujnyth').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tgz09ujnyth', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ip4e92nhskf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ip4e92nhskf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iimnddflac').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iimnddflac', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n4ml5d9ee3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n4ml5d9ee3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x49c5d9uinc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x49c5d9uinc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xiqrwimuclq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xiqrwimuclq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t21e4toh2pe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t21e4toh2pe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2etu2gh3bc2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2etu2gh3bc2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3fk9blg51e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3fk9blg51e', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-eomp936zmtv"]=  window.__ectimmers["ecom-eomp936zmtv"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-eomp936zmtv"]["65eulabil"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-eomp936zmtv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eomp936zmtv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-12eam7nmdpv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-12eam7nmdpv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-udfm4i6otl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-udfm4i6otl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ix5bca8s38f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ix5bca8s38f', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ondo0c39cw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ondo0c39cw', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8rsu3y23mcv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8rsu3y23mcv', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6merjosldxq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6merjosldxq', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-neh0krelbbj"]=  window.__ectimmers["ecom-neh0krelbbj"] || {};
var $,E,I,D,P,j;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,s=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(I=this.settings.disable_auto_close__mobile)!=null?I:!1,n=(D=this.settings.scroll_on_mobile)!=null?D:!1,r=(P=this.settings.disable_effect)!=null?P:!1,a=(j=this.settings.close_all)!=null?j:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(T=>T.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(T){const F=T.getBoundingClientRect();return F.top>=0&&F.left>=0&&F.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&F.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(T){return o&&T<768||s&&T>767&&T<1025||i&&T>1024}function b(T){if(!T)return;const F=T.style.transition;T.style.transition="none",T.style.height="auto";const H=T.scrollHeight;T.style.height="0px",T.offsetHeight,T.style.transition=F,requestAnimationFrame(()=>{const R=r?"auto":e?H+"px":"auto";T.style.height=R})}function y(T){T.classList.remove("ecom-item-active");const F=T.querySelector(":scope > .ecom-accordion__body");F&&(r||(F.style.height=F.scrollHeight+"px",F.offsetHeight),requestAnimationFrame(()=>{F.style.height="0px"}))}function v(T){let F=0;if(T.offsetParent)do F+=T.offsetTop;while(T=T.offsetParent);return F}function w(T){const F=Math.max(0,T),H=window.pageYOffset||document.documentElement.scrollTop,R=F-H;if(R===0)return;const K=300;let W=null;function G(se){W||(W=se);const te=Math.min((se-W)/K,1),Y=te<.5?2*te*te:1-Math.pow(-2*te+2,2)/2;window.scrollTo(0,H+R*Y),te<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function S(T){w(v(T)-100)}function C(T,F=!1){T.forEach((H,R)=>{const K=H.parentNode,W=K.querySelector(":scope > .ecom-accordion__body");!r&&W&&W.classList.add("ecom-effect-accodion");const G=K.classList.contains("ecom-item-active");W&&!a&&(F&&R===0||G)&&requestAnimationFrame(()=>{W.style.height=W.scrollHeight+"px"}),H.onclick=function(se){var ue,_e;if(se.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const te=m(),Y=this.parentNode,pe=Y.parentNode,ce=pe.querySelectorAll(":scope > .ecom-accordion__item"),he=Array.from(ce).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const V=this.classList.contains("ecom-item-active"),X=_(te);if(V)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ce.forEach(y),he.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(ce.forEach(y),he.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),H.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(ue=we.parentElement)==null?void 0:ue.closest)==null?void 0:_e.call(ue,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const Q=this,ge=n||te>1024;function ee(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(Q)&&S(Q)}if(ge&&!r){let we;const Ae=function(Ee){Ee.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},50))};pe.addEventListener("transitionend",Ae),setTimeout(()=>{pe.removeEventListener("transitionend",Ae),ee()},600)}else requestAnimationFrame(()=>{setTimeout(ee,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const T=t.querySelector(".ecom-item-group-init");T&&T.classList.remove("ecom-item-group-init")});function x(){const T=window.location.hash;if(T){const F=t.querySelector(`[data-target="${T}"]`);if(F){F.click(),F.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const K=F.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(K)}}}requestAnimationFrame(()=>{setTimeout(x,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",x,!1)

                    });
                    
                        document.querySelectorAll('.ecom-neh0krelbbj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-neh0krelbbj', settings: {"disable_auto_close":false,"scroll_on_mobile":true,"disable_effect":true,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zjkyos8yyxl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zjkyos8yyxl', settings: {"disable_auto_close":false,"scroll_on_mobile":true,"disable_effect":true,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b42vc3v5knl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b42vc3v5knl', settings: {"disable_auto_close":false,"scroll_on_mobile":true,"disable_effect":true,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z5lqzgdqq9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z5lqzgdqq9', settings: {"disable_auto_close":false,"scroll_on_mobile":true,"disable_effect":true,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yf0mfps6zi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yf0mfps6zi', settings: {"disable_auto_close":false,"scroll_on_mobile":true,"disable_effect":true,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ffhf9s7lcc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ffhf9s7lcc', settings: {"disable_auto_close":false,"scroll_on_mobile":true,"disable_effect":true,"close_all":true},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bxe0v4ucpyv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bxe0v4ucpyv', settings: {"disable_auto_close":false,"scroll_on_mobile":true,"disable_effect":true,"close_all":true},isLive: true});
                        });
                    

                })();
            
;try{
 window.addEventListener('load', function () {
  if (!window.location.hash) return;

  setTimeout(function () {
    const target = document.querySelector(window.location.hash);

    if (!target) return;

    const offset = 140;
    const targetPosition =
      target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'auto'
    });
  }, 300);
});
} catch(error){console.error(error);}